import { twMerge } from 'tailwind-merge';

type OptionLabelProps = {
   label: string;
   /** Smaller gray text after the label, e.g. a chapter's parent club (NPT-2274). */
   sublabel?: string | null;
   className?: string;
};

/**
 * NPT-2274 — a picker option that needs a qualifier to be told apart. Twenty clubs
 * can each have a "2033 Yellow" team; the parent club in gray after the name says
 * which one this is without the admin having to rename every team "2033 Yellow - Club".
 */
const OptionLabel = ({ label, sublabel, className }: OptionLabelProps) => (
   <span className={twMerge('flex min-w-0 items-baseline gap-1.5', className)} title={sublabel ? `${label} · ${sublabel}` : label}>
      <span className="truncate">{label}</span>
      {sublabel && <span className="max-w-[50%] shrink-0 truncate text-xs text-gray-500">{sublabel}</span>}
   </span>
);

export default OptionLabel;
